import { configureStore } from '@reduxjs/toolkit';
import styleReducer from './styleSlice';
import mainReducer from './mainSlice';
import authSlice from './authSlice';
import openAiSlice from './openAiSlice';

import usersSlice from "./users/usersSlice";
import rolesSlice from "./roles/rolesSlice";
import permissionsSlice from "./permissions/permissionsSlice";
import projectsSlice from "./projects/projectsSlice";
import suppliersSlice from "./suppliers/suppliersSlice";
import partsSlice from "./parts/partsSlice";
import warehouse_locationsSlice from "./warehouse_locations/warehouse_locationsSlice";
import inventory_balancesSlice from "./inventory_balances/inventory_balancesSlice";
import inventory_transactionsSlice from "./inventory_transactions/inventory_transactionsSlice";
import project_requirement_importsSlice from "./project_requirement_imports/project_requirement_importsSlice";
import project_requirementsSlice from "./project_requirements/project_requirementsSlice";
import purchase_ordersSlice from "./purchase_orders/purchase_ordersSlice";
import purchase_order_linesSlice from "./purchase_order_lines/purchase_order_linesSlice";
import receiptsSlice from "./receipts/receiptsSlice";
import receipt_linesSlice from "./receipt_lines/receipt_linesSlice";
import shipmentsSlice from "./shipments/shipmentsSlice";
import shipment_linesSlice from "./shipment_lines/shipment_linesSlice";
import activity_logsSlice from "./activity_logs/activity_logsSlice";
import alertsSlice from "./alerts/alertsSlice";

export const store = configureStore({
  reducer: {
    style: styleReducer,
    main: mainReducer,
    auth: authSlice,
    openAi: openAiSlice,

users: usersSlice,
roles: rolesSlice,
permissions: permissionsSlice,
projects: projectsSlice,
suppliers: suppliersSlice,
parts: partsSlice,
warehouse_locations: warehouse_locationsSlice,
inventory_balances: inventory_balancesSlice,
inventory_transactions: inventory_transactionsSlice,
project_requirement_imports: project_requirement_importsSlice,
project_requirements: project_requirementsSlice,
purchase_orders: purchase_ordersSlice,
purchase_order_lines: purchase_order_linesSlice,
receipts: receiptsSlice,
receipt_lines: receipt_linesSlice,
shipments: shipmentsSlice,
shipment_lines: shipment_linesSlice,
activity_logs: activity_logsSlice,
alerts: alertsSlice,
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
